const initialState = {
	isLoading: 0,
	hasError: 0,
	product: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case "PRODUCT_IS_LOADING":
			return {
				...state,
				isLoading: 1
			};
		case "PRODUCT_HAS_ERROR":
			return {
				...state,
				isLoading: 0,
				hasError: 1,
				error: action.error
			};
		case "PRODUCT_SUCCESS":
			return {
				...state,
				...action.payload.data,
				isLoading: 0
			};
		case "PRODUCT_UNLOAD":
			return initialState;

		case "SET_PRODUCT_PRICE":
			return {
				...state,
				final_price: action.price
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/product.js